import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class ProvinceService {

  apiUrl = environment.apiUrl

  httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient,private authservice:AuthService) { }

  getProvinces():Observable<any>
  {
    const token = this.authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });   
    return this.http.get<any>(this.apiUrl+"User/getProvinces",{headers:headers});
  }

  getProvincesForRegistration():Observable<any>
  {
    return this.http.get<any>(this.apiUrl+"User/getProvincesForRegistration");
  }


}
